<template>
  <div class="labour tableBoxShadow">
    <div class="touchLimit">
      <h5 :class="['title',{mobileFontSize:$isMobile}]">工作场所不同体力劳动强度WBGT限值（℃）</h5>
      <el-table :class="{mobileTable:$isMobile}" border :data="tableData" style="width: 100%">
        <el-table-column align="center" prop="contactTimeRate" label="接触时间率">
        </el-table-column>
        <el-table-column align="center" label="体力劳动强度">
          <el-table-column align="center" label="I">
            <template slot-scope="scope">
              <p>{{scope.row.labourIntensity.I}}</p>
            </template>
          </el-table-column>
          <el-table-column align="center" label="II">
            <template slot-scope="scope">
              <p>{{scope.row.labourIntensity.II}}</p>
            </template>
          </el-table-column>
          <el-table-column align="center" label="III">
            <template slot-scope="scope">
              <p>{{scope.row.labourIntensity.III}}</p>
            </template>
          </el-table-column>
          <el-table-column align="center" label="IV">
            <template slot-scope="scope">
              <p>{{scope.row.labourIntensity.IV}}</p>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="levelTab">
      <h5 :class="['title',{mobileFontSize:$isMobile}]">体力劳动强度分级表</h5>
      <el-table :class="{mobileTable:$isMobile}" border :data="levelData" style="width: 100%">
        <el-table-column align="center" prop="level" label="体力劳动强度级别">
        </el-table-column>
        <el-table-column align="center" prop="laborIntensityIndex" label="劳动强度指数（n）">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        tableData:[],
        levelData:[]
      }
    },
    created() {
      this.findLabourIntensitys()
      this.findLaborIntensityLevel()
    },
    methods:{
      async findLabourIntensitys(){
        let res = await this.$axios.get(this.$serviceAPI.findLabourIntensitys)
        this.tableData = res.data.data
      },
      async findLaborIntensityLevel(){
        let res = await this.$axios.get(this.$serviceAPI.findLaborIntensityLevel)
        this.levelData = res.data.data
      }
    },
    }
</script>

<style scoped="scoped">
  .touchLimit{
    width: 100%;
  }
  .labour{
    display: flex;
    flex-wrap: wrap;
  }
  .labour .touchLimit{
    flex:5;
    margin-right: 1.25rem;
  }
  .levelTab{
    flex:5;
  }
</style>



// WEBPACK FOOTER //
// src/components/subPage/labourIntensity.vue